// frontend/src/services/urlMask.js
//
// URL masking — obscures API route NAMES in the browser Network tab by encoding
// the real relative path+query into an opaque token under a sentinel prefix, so
// requests appear as `/api/__/<token>` instead of `/api/admin/users` etc.
//
// SECURITY NOTE: this is security-by-OBSCURITY, not access control. The key below
// ships in the client bundle and is extractable; the token is reversible by anyone
// who reads it. It only keeps route names out of the Network tab — real protection
// is the server-side auth on every /api/ route. The backend counterpart that decodes
// these tokens lives in backend/app/middleware/url_mask.py and MUST use the same key.

// Default is intentionally identical to the backend default (url_mask.py) so that if
// the env var is left unset on either side they still agree. Override via env to rotate.
const KEY = process.env.REACT_APP_URL_MASK_KEY || "tf_url_mask_2026";
const SENTINEL = "/__/";
const enc = new TextEncoder();
const KEY_BYTES = enc.encode(KEY);

function xorBytes(bytes, key) {
  const out = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i++) out[i] = bytes[i] ^ key[i % key.length];
  return out;
}

function b64url(bytes) {
  let bin = "";
  for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

// Encode a RELATIVE path (+ optional query), e.g. "/admin/users?page=1", into
// "/__/<token>". Deterministic and idempotent (already-masked input passes through).
export function maskPath(pathAndQuery) {
  if (typeof pathAndQuery !== "string" || !pathAndQuery) return pathAndQuery;
  if (pathAndQuery.startsWith(SENTINEL)) return pathAndQuery; // already masked
  return SENTINEL + b64url(xorBytes(enc.encode(pathAndQuery), KEY_BYTES));
}

// Convenience for raw fetch() sites that include the /api prefix in the literal URL.
// maskApiUrl("/users/me") -> "/api/__/<token-of-/users/me>"
export function maskApiUrl(rel) {
  return "/api" + maskPath(rel);
}
